import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BookingsApi - axios parameter creator
 * @export
 */
const BookingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {number} [status]
         * @param {number} [bookingTypeId]
         * @param {number} [customerId]
         * @param {number} [takeAwayStoreId]
         * @param {String} [fromDate]
         * @param {String} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export: async (searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options = {}) => {
            const localVarPath = `/v1/Bookings/Export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (takeAwayStoreId !== undefined) {
                localVarQueryParameter['takeAwayStoreId'] = takeAwayStoreId;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString() :
                    toDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancels one of the authenticated storefront customer\'s own bookings while it is still ahead of them (Pending or Confirmed, not started yet), with the same notification and loyalty event as an admin cancellation. (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMyBooking: async (id, options = {}) => {
            const localVarPath = `/v1/Bookings/CancelMyBooking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {ConflictCheckRequest} [ConflictCheckRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConflicts: async (ConflictCheckRequest, options = {}) => {
            const localVarPath = `/v1/Bookings/CheckConflicts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ConflictCheckRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingGetAllRequest} [BookingGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (BookingGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Bookings/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailability: async (bookingTypeId, startDate, endDate, customerId, options = {}) => {
            const localVarPath = `/v1/Bookings/GetAvailability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Bookings/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the authenticated storefront customer\'s own bookings (newest first), cancelled ones left out. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBookings: async (options = {}) => {
            const localVarPath = `/v1/Bookings/GetMyBookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {CreateBookingRequest} [CreateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CreateBookingRequest, options = {}) => {
            const localVarPath = `/v1/Bookings/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CreateBookingRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Bookings/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingUpdateToken} [BookingUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (BookingUpdateToken, options = {}) => {
            const localVarPath = `/v1/Bookings/UpdateStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingUpdateToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {ValidateBookingRequest} [ValidateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBooking: async (ValidateBookingRequest, options = {}) => {
            const localVarPath = `/v1/Bookings/ValidateBooking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ValidateBookingRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BookingsApi - functional programming interface
 * @export
 */
const BookingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BookingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {number} [status]
         * @param {number} [bookingTypeId]
         * @param {number} [customerId]
         * @param {number} [takeAwayStoreId]
         * @param {String} [fromDate]
         * @param {String} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator._export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi._export']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Cancels one of the authenticated storefront customer\'s own bookings while it is still ahead of them (Pending or Confirmed, not started yet), with the same notification and loyalty event as an admin cancellation. (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMyBooking(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMyBooking(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.cancelMyBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {ConflictCheckRequest} [ConflictCheckRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkConflicts(ConflictCheckRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkConflicts(ConflictCheckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.checkConflicts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingGetAllRequest} [BookingGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(BookingGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(BookingGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailability(bookingTypeId, startDate, endDate, customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailability(bookingTypeId, startDate, endDate, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns the authenticated storefront customer\'s own bookings (newest first), cancelled ones left out. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyBookings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyBookings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.getMyBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {CreateBookingRequest} [CreateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CreateBookingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CreateBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingUpdateToken} [BookingUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(BookingUpdateToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(BookingUpdateToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.updateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {ValidateBookingRequest} [ValidateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBooking(ValidateBookingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBooking(ValidateBookingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingsApi.validateBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BookingsApi - factory interface
 * @export
 */
const BookingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BookingsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {number} [status]
         * @param {number} [bookingTypeId]
         * @param {number} [customerId]
         * @param {number} [takeAwayStoreId]
         * @param {String} [fromDate]
         * @param {String} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options) {
            return localVarFp._export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancels one of the authenticated storefront customer\'s own bookings while it is still ahead of them (Pending or Confirmed, not started yet), with the same notification and loyalty event as an admin cancellation. (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMyBooking(id, options) {
            return localVarFp.cancelMyBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {ConflictCheckRequest} [ConflictCheckRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConflicts(ConflictCheckRequest, options) {
            return localVarFp.checkConflicts(ConflictCheckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingGetAllRequest} [BookingGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(BookingGetAllRequest, options) {
            return localVarFp.getAll(BookingGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailability(bookingTypeId, startDate, endDate, customerId, options) {
            return localVarFp.getAvailability(bookingTypeId, startDate, endDate, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the authenticated storefront customer\'s own bookings (newest first), cancelled ones left out. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBookings(options) {
            return localVarFp.getMyBookings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {CreateBookingRequest} [CreateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CreateBookingRequest, options) {
            return localVarFp.insert(CreateBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingUpdateToken} [BookingUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(BookingUpdateToken, options) {
            return localVarFp.updateStatus(BookingUpdateToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {ValidateBookingRequest} [ValidateBookingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBooking(ValidateBookingRequest, options) {
            return localVarFp.validateBooking(ValidateBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BookingsApi - object-oriented interface
 * @export
 * @class BookingsApi
 * @extends {BaseAPI}
 */
class BookingsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {string} [searchText]
     * @param {number} [status]
     * @param {number} [bookingTypeId]
     * @param {number} [customerId]
     * @param {number} [takeAwayStoreId]
     * @param {String} [fromDate]
     * @param {String} [toDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    _export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options) {
        return BookingsApiFp(this.configuration)._export(searchText, status, bookingTypeId, customerId, takeAwayStoreId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancels one of the authenticated storefront customer\'s own bookings while it is still ahead of them (Pending or Confirmed, not started yet), with the same notification and loyalty event as an admin cancellation. (Auth roles: FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    cancelMyBooking(id, options) {
        return BookingsApiFp(this.configuration).cancelMyBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {ConflictCheckRequest} [ConflictCheckRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    checkConflicts(ConflictCheckRequest, options) {
        return BookingsApiFp(this.configuration).checkConflicts(ConflictCheckRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingGetAllRequest} [BookingGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    getAll(BookingGetAllRequest, options) {
        return BookingsApiFp(this.configuration).getAll(BookingGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {number} [bookingTypeId]
     * @param {String} [startDate]
     * @param {String} [endDate]
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    getAvailability(bookingTypeId, startDate, endDate, customerId, options) {
        return BookingsApiFp(this.configuration).getAvailability(bookingTypeId, startDate, endDate, customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    getById(id, options) {
        return BookingsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the authenticated storefront customer\'s own bookings (newest first), cancelled ones left out. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    getMyBookings(options) {
        return BookingsApiFp(this.configuration).getMyBookings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {CreateBookingRequest} [CreateBookingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    insert(CreateBookingRequest, options) {
        return BookingsApiFp(this.configuration).insert(CreateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    remove(id, options) {
        return BookingsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingUpdateToken} [BookingUpdateToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    updateStatus(BookingUpdateToken, options) {
        return BookingsApiFp(this.configuration).updateStatus(BookingUpdateToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {ValidateBookingRequest} [ValidateBookingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    validateBooking(ValidateBookingRequest, options) {
        return BookingsApiFp(this.configuration).validateBooking(ValidateBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BookingsApi, BookingsApiAxiosParamCreator, BookingsApiFactory, BookingsApiFp };
//# sourceMappingURL=bookings-api.js.map
